import React, { useEffect } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { resetReviewManageSidepanelState } from 'reducers/reviewManageSidepanelSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import noInsights from 'assets/assetsV1/illustrations/deerIllustrations/noInsights.svg';

import { AgGridSearchBar } from 'uiToolkitV1/AgGridSearchBar';
import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { BulkActionContextProvider } from '../ReviewManage/components/ReviewManageTable/components/BulkActions/BulkActionContext';
import { BulkActionHeader } from '../ReviewManage/components/ReviewManageTable/components/BulkActions/BulkActionHeader';
import { PartialPublishContextProvider } from '../ReviewManage/components/ReviewManageTable/components/ShareResultsDrawer/PartialPublishContext';
import ShareResultsDrawer from '../ReviewManage/components/ReviewManageTable/components/ShareResultsDrawer/ShareResultsDrawer';
import { TalentPlanningAGGrid } from './TalentPlanningAGGrid';
import { useGetTalentPlanningTabularData } from './dataHooks';
import { useCalibrationViewLandingQueryParams } from './helpers';

function TalentPlanningIntent({ gridRef }) {
  const dispatch = useDispatch();
  const cohortDetails = useSelectedView();
  const { calibrationViewId: queryParamCalibrationViewId } = useCalibrationViewLandingQueryParams();

  const {
    isFetching,
    data: reviewsManageData,
    error,
  } = useGetTalentPlanningTabularData({
    cohortId: cohortDetails?.id,
    calibrationViewId: queryParamCalibrationViewId,
  });

  useEffect(
    () => () => {
      dispatch(resetReviewManageSidepanelState());
    },
    [dispatch]
  );

  return (
    <Box position="relative">
      <Box p={!checkNewNavEnabled() ? 4 : 0}>
        <PaperWithShadow p={4} mb={1} position="relative">
          {error && (
            <EmptyScreen
              heading="Calibration view not available!"
              description={
                error?.message ?? 'There was some issue in loading calibration view. Please try again later.'
              }
              illustrationSrc={noInsights}
            />
          )}

          {!error && (
            <>
              <Flex justifyContent="space-between" alignItems="center" mb={2}>
                <AgGridSearchBar gridRef={gridRef} />
              </Flex>
              <PartialPublishContextProvider>
                <BulkActionContextProvider>
                  <BulkActionHeader
                    clearSelection={() => gridRef.current.api.deselectAll()}
                    selectAll={() => gridRef.current.api.selectAll('filtered')}
                    isOnlyPublishAction
                  />
                  <ShareResultsDrawer />
                  <TalentPlanningAGGrid
                    agGridRef={gridRef}
                    isFetching={isFetching}
                    reviewsManageData={reviewsManageData}
                  />
                </BulkActionContextProvider>
              </PartialPublishContextProvider>
            </>
          )}
        </PaperWithShadow>
      </Box>
    </Box>
  );
}

export { TalentPlanningIntent };
